import React, { PureComponent } from 'react';
import Modal from 'react-modal';
import { compose } from 'redux';
import { withRouter } from 'react-router-dom';
import withMenuModals from '../../containers/Modals/menu';
import { withMenu } from '../../containers/Menus';
import { customModalStyles, PATHS } from '../../helpers/constants';
import * as styles from './style';
import ConfirmIcon from '../Icons/Confirm';
import { getParentSelector } from '../../helpers/modal';

class PublishMenuModal extends PureComponent {
  publish = value => {
    this.props.publishMenu(value, {
      id: this.props.menuPersisted.id,
      merchantId: this.props.menuPersisted.merchantId,
    });
  };

  componentDidUpdate() {
    const { isPublishMenuFinished } = this.props;
    if (isPublishMenuFinished) {
      this.props.closeModal();
      this.props.finishPublishMenu();
      this.props.history.push(PATHS.menu);
    }
  }

  render() {
    const { modal } = this.props;
    return (
      <Modal
        ariaHideApp={false}
        isOpen={modal.showPublishMenuModal}
        // onRequestClose={() => {}}
        style={{
          ...customModalStyles,
          content: {
            ...customModalStyles.content,
            width: '90%',
            maxWidth: '450px',
            height: 'auto',
          },
        }}
        parentSelector={getParentSelector}
      >
        <styles.Container>
          <styles.Content>
            <ConfirmIcon size="120px" />
            <styles.Title>Cardápio criado com sucesso!</styles.Title>
            <styles.Desc>Deseja publicar seu cardápio agora mesmo?</styles.Desc>
          </styles.Content>
          <styles.Footer>
            <styles.SecondaryButton onClick={() => this.publish(false)}>
              Publicar mais tarde
            </styles.SecondaryButton>
            <styles.PrimaryButton onClick={() => this.publish(true)}>
              Sim, publicar agora
            </styles.PrimaryButton>
          </styles.Footer>
        </styles.Container>
      </Modal>
    );
  }
}

const PublishMenuComposed = compose(
  withMenu,
  withMenuModals,
  withRouter
)(PublishMenuModal);

export default PublishMenuComposed;



// WEBPACK FOOTER //
// ./src/components/PublishMenuModal/index.js